<template>
  <AppLayout>
    <router-view />
  </AppLayout>
  <SiteAnalytics />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { usePaletteStore } from '@/stores/palette'
import AppLayout from '@/components/AppLayout.vue'
import SiteAnalytics from '@/components/SiteAnalytics.vue'
import { showToast } from '@/utils/platform-ui'

const paletteStore = usePaletteStore()

onMounted(() => {
  paletteStore.loadPalettes().catch(() => {
    showToast({ title: '色板加载失败，请刷新页面重试', icon: 'none' })
  })
})
</script>
